var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 9.167a1.25 1.25 0 000 2.5h5.834a1.25 1.25 0 000-2.5h-5.834zm-1.25 10.416a1.25 1.25 0 011.25-1.25h5.834a1.25 1.25 0 010 2.5h-5.834a1.25 1.25 0 01-1.25-1.25zM12.967 7.867a1.25 1.25 0 010 1.766l-3.334 3.334a1.25 1.25 0 01-1.766 0L6.2 11.3a1.25 1.25 0 011.767-1.767l.783.784 2.45-2.45a1.25 1.25 0 011.767 0zm0 10.933a1.249 1.249 0 10-1.767-1.767l-2.45 2.45-.783-.783A1.25 1.25 0 006.2 20.467l1.667 1.666a1.25 1.25 0 001.766 0l3.334-3.333zM3.75 0A3.75 3.75 0 000 3.75v22.5A3.75 3.75 0 003.75 30h22.5A3.75 3.75 0 0030 26.25V3.75A3.75 3.75 0 0026.25 0H3.75zM2.5 3.75A1.25 1.25 0 013.75 2.5h22.5a1.25 1.25 0 011.25 1.25v22.5a1.25 1.25 0 01-1.25 1.25H3.75a1.25 1.25 0 01-1.25-1.25V3.75z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.93f91134.svg";
export { ForwardRef as ReactComponent };